import { render, staticRenderFns } from "./RenewPasswordPage.vue?vue&type=template&id=33f03e4a&scoped=true"
import script from "./RenewPasswordPage.vue?vue&type=script&lang=js"
export * from "./RenewPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./RenewPasswordPage.vue?vue&type=style&index=0&id=33f03e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f03e4a",
  null
  
)

export default component.exports